import { render, staticRenderFns } from "./TitlePrincipal.vue?vue&type=template&id=fab8bef2"
import script from "./TitlePrincipal.vue?vue&type=script&lang=js"
export * from "./TitlePrincipal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports